import { USER_PERMISSIONS } from 'components/modules/Management/AccessManagement/helper';
import SingleNetwork from 'components/modules/SingleNetwork/SingleNetwork';
import { checkSinglePermission } from 'components/shared/helper';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { accessActions } from '../redux/slice/access.slice';
import { authActions } from '../redux/slice/auth.slice';

const SingleNetworkPage = () => {

    const navigate = useNavigate();
    const currentUser = useSelector(authActions.selectors.getCurrentUser);
    const userPermissions = useSelector(accessActions.selectors.getUserPermissions)


    useEffect(() => {
        if (userPermissions?.length && currentUser?.role) {
            if (!checkSinglePermission(USER_PERMISSIONS.VIEW_NETWORK_DETAILS, userPermissions, currentUser?.role)) {
                toast.error("You do not have permission to view this page.");
                navigate("/devices");
            }
        }
    }, [userPermissions, currentUser?.role, navigate])
    return (
        <SingleNetwork />
    )
}

export default SingleNetworkPage
